import classnames from 'classnames';
import React from 'react';
import { Nav, NavProps } from '../Nav';
import './Navbar.scss';

export type NavbarProps = NavProps;

export const Navbar = ({ className, ...props }: NavbarProps) => {
  const navbarClassName = classnames('navbar', className);
  return (
    <div className={navbarClassName}>
      <Nav {...props} />
    </div>
  );
};
